(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Keeping the header on screen is pure CSS (.section-header { position: sticky } in base.css).
  // The element is kept because cart-notification.js, media-gallery.js and quick-order-list.js look it up.
  // There is no scroll behavior: the header never hides or shrinks.
  class StickyHeader extends HTMLElement {
    // Called by cart-notification.js; the header is never hidden, so there is nothing to reveal.
    reveal() {}
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
